import styledComponentsRhythm from "@ceteio/styled-components-rhythm";

export const rhythm = styledComponentsRhythm({
  baseFontSize: 2, // 1rem. Browser default makes this 16px
  baseLineHeight: 1.25, // unitless line-height, see: https://css-tricks.com/almanac/properties/l/line-height/#comment-1587658
  rhythmHeight: 0.25, // rem units. With browser default, this is 16px * 0.75rem == 12px
  capHeights: {
    AvenirLTRoman: 0.72,
    AvenirLTBold: 0.72,
    AvenirLTLight: 0.72,
    AvenirLTHeavy: 0.72
  }
});

export const theme = {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  spacing: {
    xxs: 0.5,
    xs: 1,
    s: 2,
    m: 4,
    l: 6,
    xl: 14
  },
  cardRatio: 0.7,
  font: {
    h1: {
      size: "3",
      family: "AvenirLTBold",
      lineHeight: "1",
      smallSize: "2"
    },
    h2: {
      size: "2",
      card: "1.5",
      family: "AvenirLTBold",
      lineHeight: "1",
      smallSize: "1.2",
      smallCard: "1.1",

    },
    h4: {
      size: "1",
      card: "1",
      family: "AvenirLTBold",
      lineHeight: "1.5",
      smallSize: "0.8",
      smallCard: "0.7",

    },
    p: {
      size: "0.95",
      smallSize: "0.7",
      card: "0.83",
      family: "AvenirLTLight",
      familyBold: "AvenirLTBold",
      lineHeight: "1.8"
    },
    caption: {
      size: "0.8",
      family: "AvenirLTLightOblique",
      lineHeight: "1.8"
    },
    button: {
      size: "0.8",
      family: "AvenirLTRoman",
      lineHeight: "1"
    },
    navLink:{
      size: "1",
      family: "AvenirLTBold",
      lineHeight: "1.8"
    }
  },
  color: {
    first: "#4d80ff",
    primary: "#4d80ff",
    second: "#fd5c4c",
    third: "#22c087",
    fourth: "#ffd41d",
    backgroundShade: "#faf9f9",
    tints: {
      half:{
        first: "#4d80ff",
        primary: "#4d80ff",
        second: "#fc8781",
        third: "#22c087",
        fourth: "#ffd41d",
      },
      quarter:{
        first: "#b6ceff",
        primary: "#4d80ff",
        second: "#ffdddc",
        third: "#22c087",
        fourth: "#ffd41d",
      }
    }
  }
};

